export const colors = {
  blue: '#04f5ff',
  pink: '#e90052',
  white: '#ffffff',
  green: '#00ff85',
  purple: '#38003c',
};

export default colors;
